import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import noop from '../../../util/noop';

const maybeLoadQzzr = () => {
  let el = document && document.getElementById('qzzr-js');

  if (document && !el) {
    el = document.createElement('script');
    el.id = 'wistia-js';
    el.async = true;
    el.defer = true;
    el.src = '//dcc4iyjchzom0.cloudfront.net/widget/loader.js';

    document.body.appendChild(el);
  }
};

const Qzzr = ({ id }) => {
  useEffect(maybeLoadQzzr, [id]);

  return (
    <div
      class='quizz-container'
      data-width='100%'
      data-height='auto'
      data-quiz={id}
    ></div>
  );
};

Qzzr.propTypes = {
  id: PropTypes.string.isRequired,
};

export default Qzzr;
